import { render, staticRenderFns } from "./SectorsMap.vue?vue&type=template&id=5e20edc8&scoped=true&"
import script from "./SectorsMap.vue?vue&type=script&setup=true&lang=js&"
export * from "./SectorsMap.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20edc8",
  null
  
)

export default component.exports